import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom' // IBM Plex Sans with multiple weights
import '@fontsource/ibm-plex-sans/100.css' // Thin
import '@fontsource/ibm-plex-sans/300.css' // Light
import '@fontsource/ibm-plex-sans/400.css' // Regular
import '@fontsource/ibm-plex-sans/500.css' // Medium
import '@fontsource/ibm-plex-sans/600.css' // SemiBold
import '@fontsource/ibm-plex-sans/700.css' // Bold

import './index.css'

import Experience from './pages/Experience'
import CameraFinder from './pages/CameraFinder'

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/experience/:id" element={<Experience />} />
        <Route path="/camera-finder/:id" element={<CameraFinder />} />
        <Route path="/" element={<Navigate to="/experience/2" replace />} />
      </Routes>
    </Router>
  )
}
